import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import KybLandingPage, { loader as kybLandingPageLoader } from './pages/kybLandingPage/KybLandingPage';

const router = [
  {
    path: '/',
    loader: kybLandingPageLoader,
    element: <KybLandingPage />,
  },
  {
    path: '/index.html',
    loader: kybLandingPageLoader,
    element: <KybLandingPage />,
  },
];

const Root: React.FC = () => {
  return <RouterProvider router={createBrowserRouter(router)} />;
};

export default Root;
